import React, {useState, useEffect} from 'react';
import Modal from 'react-bootstrap/Modal';
import { Link, useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { FormCad } from '../components';
import Swal from 'sweetalert2';
import initialData from './initialData';
import schema from './schema'
import { storeTipoUser, loadTipoUsers } from '~/store/modules/tipo_user/action';

const Create = () => {
  let history = useHistory();
  const [tipo_user, setTipoUser] = useState(initialData);
  const [saved, setSaved] = useState(false);
  const [errorsValidate, setErrorsValidate] = useState([]);
  const dispatch = useDispatch();
  const { status_response, errors } = useSelector(({ TipoUserReducer }) => TipoUserReducer);

  useEffect(() => {
    if (errors.status) {
      let server_errors = {};
      const response_errors = errors.data.errors;
      switch (errors.status) {
        case 422:
          for (let name of Object.keys(response_errors)) {
            Object.assign(server_errors, { [name]: response_errors[name][0] });
          }
          setErrorsValidate(server_errors);
          break;
        case 401:
          Swal.fire(
            'ERROR',
            'Você não tem permissão para acessar esse recurso',
            'error'
          ).then(() => {
            history.goBack();
          });
          break;
        default:
          break;
      }
    }
    if (errors.save) {
      setSaved(errors.save);
    }
  }, [errors, history]);


  useEffect(() => {
    if (saved && status_response === 201) {
      Swal.fire('Sucesso', 'Registro salvo com sucesso!', 'success').then(
        () => {
          history.goBack();
          dispatch(loadTipoUsers());
        }
      );
    }
  }, [status_response, history, dispatch, saved]);


  const handleClose = () => {
    history.push('/tipo_user');
  };

  const handleSubmit = async event => {
    event.preventDefault();
    if (!schema.isValidSync(tipo_user)) {
      let yup_errors = {};
      schema.validate(tipo_user, { abortEarly: false }).catch(err => {
        for (let error of err.inner) {
          const { path, message } = error;
          Object.assign(yup_errors, { [path]: message });
        }
        setErrorsValidate(yup_errors);
      });
    } else {
      await dispatch(storeTipoUser(tipo_user));
    }
  };
  return (
    <Modal
      aria-labelledby="contained-modal-title-vcenter"
      dialogClassName="modal-xl"
      onHide={handleClose}
      show
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">TipoUser</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="card">
          <div className="card-header">
            <h2 className="card-title">Novo</h2>
          </div>
          <div className="card-body">
            <FormCad
              errors={errorsValidate}
              tipo_user={tipo_user}
              handleSubmit={handleSubmit}
              schema={schema}
              setTipoUser={setTipoUser}
            />
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Link
          className="btn btn-default"
          to="/tipo_user"
        >
          <i className="fa fa-window-close" /> Cancelar
        </Link>
        <button
          className="btn btn-success"
          form="form_tipo_user"
          type="submit"
        > <i className="fa fa-save" /> Salvar
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default Create;
